import React, { useRef } from "react";
import { FormControl, InputLabel, useTheme } from "@material-ui/core";
import DatePicker from "react-datepicker2";
import { useSelector } from "react-redux";
import * as Icons from "react-bootstrap-icons";

const DatePickerComponent = ({
  label,
  onChange,
  value,
  readOnly = false,
  validation
}) => {
  const { direction } = useTheme();
  const datePickerRef = useRef(null);
  const { rtlLayout } = useSelector((state) => ({
    rtlLayout: state.settings.rtlLayout,
  }));
  const openDatepicker = () => {
    try {
      datePickerRef.current.setOpen(true);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
  return (
    <FormControl
      dir={direction}
      component="fieldset"
      className={`datePicker ${rtlLayout ? "alignRight" : "alignLeft"}`}
    >
      <InputLabel htmlFor={`cal-${label}`}>
        {label}
      </InputLabel>
      <div className={`inner-date-picker ${validation ? 'validation-error' : ''}`} onClick={openDatepicker}>
        <DatePicker
          onChange={onChange}
          value={value || null}
          id={`cal-${label}`}
          timePicker={false}
          isGregorian={direction === 'rtl' ? false : true}
          inputReadOnly={readOnly}
          ref={datePickerRef}
        />
        <div className="cal-icon">
          <Icons.Calendar3 size={20} />
        </div>
      </div>
    </FormControl>
  );
};

export default DatePickerComponent;
